import { Component, HostBinding } from '@angular/core';
import {
    trigger,
    state,
    style,
    animate,
    transition,
    // ...
} from '@angular/animations';

export const authFade = trigger('authFade', [
    state('*', style({})),

    state('void', style({
        opacity: '0'
    })),


    transition('void => *', [
        animate('.5s')
    ]),
]);